import Vue from "vue";
import Vuex from "vuex";
import _get from "lodash/get";
import { firebase } from "../helpers/firebase";
import usuarioStore from "./usuario.store";
import grupoStore from "./grupo.store";
import colegioStore from "./colegio.store";
import mensajeStore from "./mensaje.store";
import salaStore from "./sala.store";
import grupoUsuarioStore from "./grupo_usuario.store";

Vue.use(Vuex);

const firestore = firebase.firestore();

export default new Vuex.Store({
  state: {
    user: null,
    usersubscriber: null,
    publicadores: [],
    ...usuarioStore.state,
    ...grupoStore.state,
    ...colegioStore.state,
    ...mensajeStore.state,
    ...salaStore.state,
    ...grupoUsuarioStore.state
  },
  mutations: {
    setState: (state, pay) => {
      // eslint-disable-next-line no-prototype-builtins
      state.hasOwnProperty(_get(pay, "key", "NA"))
        ? (state[_get(pay, "key", "NA")] = _get(pay, "value", null))
        : null;
    }
  },
  actions: {
    ChargeBasics({ dispatch }) {
      dispatch("listColegio");
    },
    CleanBasics({ dispatch }) {
      dispatch("cleanAllColegio");
      dispatch("cleanAllUsuario");
    },
    initAuthAction({ commit, dispatch, state }) {
      return firebase.auth().onAuthStateChanged(async value => {
        if (value) {
          const userInfo = firestore
            .collection("usuarios")
            .doc(`dc_${value.uid}`);
          const result = await userInfo
            .get()
            .then(snap => snap.exists && !snap.data().deleted);
          if (result) {
            const unsuscriber = userInfo.onSnapshot(doc => {
              const userInfo = { id: doc.id, ...doc.data() };
              if (userInfo.deleted) dispatch("logoutAction");
              else {
                commit("setState", {
                  key: "user",
                  value: { ...value, userInfo }
                });
                dispatch("ChargeBasics");
              }
            });
            commit("setState", { key: "usersubscriber", value: unsuscriber });
            return true;
          }
          dispatch("logoutAction");
          return false;
        } else {
          if (typeof state.usersubscriber === "function")
            state.usersubscriber();
          commit("setState", { key: "usersubscriber", value: null });
          dispatch("CleanBasics");
        }
      });
    },
    loginAction(ctx, { email, password }) {
      return firebase.auth().signInWithEmailAndPassword(email, password);
    },
    restoreAction(ctx, { email }) {
      return firebase.auth().sendPasswordResetEmail(email);
    },
    logoutAction() {
      return firebase
        .auth()
        .signOut()
        .then(() => location.reload());
    },
    ...usuarioStore.actions,
    ...grupoStore.actions,
    ...colegioStore.actions,
    ...mensajeStore.actions,
    ...salaStore.actions,
    ...grupoUsuarioStore.actions
  },
  modules: {},
  getters: {
    userLogged: state => {
      return _get(state.user, "userInfo", null);
    }
  }
});
